import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import { ClinicalAlert, ClinicalAlertCreate, ClinicalAlertUpdate } from "../../domain/ClinicalAlert";

export const ClinicalAlertsAPI = {
    list: (): Promise<AxiosResponse<ClinicalAlert[]>> => apiClient.get("/clinical-alerts/"),
    create: (data: ClinicalAlertCreate): Promise<AxiosResponse<ClinicalAlert>> => apiClient.post("/clinical-alerts/", data),
    update: (id: string, data: ClinicalAlertUpdate): Promise<AxiosResponse<ClinicalAlert>> => apiClient.patch(`/clinical-alerts/${id}`, data),
    delete: (id: string): Promise<AxiosResponse<void>> => apiClient.delete(`/clinical-alerts/${id}`),
};
